module.exports = __webpack_public_path__ + "static/screenshot2-b5d6f2e0d91a7486a45b3979e175fa49.jpg";